import { render, staticRenderFns } from "./messageNotification.vue?vue&type=template&id=1d8fed33"
import script from "./messageNotification.vue?vue&type=script&lang=js"
export * from "./messageNotification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports